'use strict';

const {isPageType} = require('../pageTypeHelper');
const {PAGE_TYPE: {PDP}} = require('../../constants/pageTypes');
const referrerHelpers = require('../../tracking/referrerHelpers');

const pinterestActions = require('../../actions/pinterestActions');

const pinterestConnectAccountsModalRule = payload => {
    const {context} = payload;
    const successResponse = {
        success: true,
        type: 'pinterestReferrer'
    };

    if (!isPageType(PDP) || !referrerHelpers.isPinterestReferrer()) {
        return Promise.resolve({success: false});
    }

    return context
        .executeAction(pinterestActions.initApp)
        .then(() => context.executeAction(pinterestActions.canShowConnectAccountPromotion))
        .then(() => context.executeAction(pinterestActions.showConnectAccountsModal))
        .then(() => successResponse);
};

module.exports = pinterestConnectAccountsModalRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/pinterestConnectAccountsModalRule.es.js